import { Network } from '@plug-core/interfaces/common'
import { useDevMode } from '@plug-core/state'
import { Button, IconButton, ListGroup, ListRow } from '@ui'
import { ROUTES } from '@utils/routes'
import React from 'react'
import { HiMiniPencil } from 'react-icons/hi2'
import { useNavigate } from 'react-router-dom'

const NetworkList = () => {
  const navigate = useNavigate()

  const { networks, setActiveNetwork, activeNetwork } = useDevMode()

  const activateNetwork = (network: Network) => {
    setActiveNetwork(network.id)
    navigate(-1)
  }

  const renderNetworkRow = (network: Network) => (
    <div
      key={network.id}
      role="listitem"
      className="cursor-pointer transition-colors duration-150 hover:bg-surface-2"
      onClick={() => activateNetwork(network)}
    >
      <ListRow
        role="presentation"
        primary={
          <span className={activeNetwork === network.id ? 'text-success' : 'text-fg'}>
            {network.name}
          </span>
        }
        secondary={network.hostUrl}
        trailing={
          <IconButton
            aria-label="Edit network"
            size="sm"
            onClick={(e) => {
              // The row activates the network; editing must not.
              e.stopPropagation()
              navigate(ROUTES.DEVELOPER_SETTINGS_EDIT_NETWORK(network.id))
            }}
          >
            <HiMiniPencil />
          </IconButton>
        }
      />
    </div>
  )

  return (
    <div className="mb-3 flex flex-col gap-4">
      {Object.values(networks).length > 0 && (
        <ListGroup>{Object.values(networks).map(renderNetworkRow)}</ListGroup>
      )}
      <Button
        variant="primary"
        onClick={() => navigate(ROUTES.DEVELOPER_SETTINGS_NEW_NETWORK)}
        fullWidth
      >
        Create Network
      </Button>
    </div>
  )
}

export default NetworkList
